import axios from "axios";
import Configuration from "./configuration";

axios.interceptors.request.use(
  (config) => {
    const url = config.url || "";

    if (url.includes("/Command/SendSync")) {
      config.headers = config.headers || {};
      config.headers["x-api-key"] = Configuration.API_KEY;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
